import { render, staticRenderFns } from "./Holdgennemsnit.vue?vue&type=template&id=c828e208&"
import script from "./Holdgennemsnit.vue?vue&type=script&lang=ts&"
export * from "./Holdgennemsnit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports